export default __webpack_public_path__ + "static/achievement_national-3ba821b63f9ae213ceda7acdf667e37b.png";